import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  Inject,
} from "@angular/core";
import { UntypedFormControl, Validators, AbstractControl } from "@angular/forms";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatDialog } from "@angular/material/dialog";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import { SuccessDialogComponent } from "../dialogs/success-dialog/success-dialog.component";
import { Router } from "@angular/router";
import { LocalstorageService } from "../services/localstorage.service";
import { SurveyService } from "../services/survey.service";
import { Verification } from "../models/verification.model";
import { Employee } from "../models/employee.model";
import { SkipDialogComponent } from "../dialogs/skip-dialog/skip-dialog.component";

import * as _moment from "moment";
const moment = _moment;
import { AuthDetails } from "../models/auth-details.model";
import { ToastrWrapperService } from "../services/toastr-wrapper.service";
import { CustomHeader } from "./customheader.component";
import { DataService } from "../services/GlobalService/data.service";

export function ValidateCorpIdOrEmail(control: AbstractControl) {
  const val = control && control.value ? String(control.value) : "";
  if (!val.startsWith("https") || !val.includes(".io")) {
    return { corpIdOrEmail: true };
  }
  return null;
}

export const MY_FORMATS = {
  parse: {
    dateInput: "MM/DD/YYYY",
  },
  display: {
    dateInput: "MM/DD",
    monthYearLabel: "MMM",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-verification",
  templateUrl: "./verification.component.html",
  styleUrls: ["./verification.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class VerificationComponent implements OnInit {
  @ViewChild("recaptcha", { static: true }) recaptchaElement: ElementRef<HTMLDivElement>;

  customHeader = CustomHeader;
  isNewhire = false;
  email = new UntypedFormControl("", [
    Validators.required,
    Validators.pattern("^[a-zA-Z0-9]+$"),
  ]);
  newEmail = new UntypedFormControl("", [Validators.required, Validators.email]);
  lastName = new UntypedFormControl("", [Validators.required]);
  employeeId = new UntypedFormControl("", [Validators.required]);
  dateOfBirth = new UntypedFormControl("", [Validators.required]);
  phoneNumber = new UntypedFormControl("", [
    Validators.required,
    Validators.pattern("^[0-9]{10}$"),
  ]);

  verificationData: Verification;
  employee: Employee;
  isSubmitting = false;
  isRecaptchaValid = false;
  isProductionUrl = true;
  minDate: Date;
  maxDate: Date;
  isPreshift = false;
  isGovSurvey = false;
  btnText = "Start My Survey";
  authSkipped = false;

  endsWithNumberRegex = new RegExp("[0-9]$");
  isCorpId = true;

  constructor(
    @Inject("BASE_URL") public baseUrl: string,
    public dialog: MatDialog,
    private router: Router,
    private localstorageService: LocalstorageService,
    private surveyService: SurveyService,
    private toasterWrapper: ToastrWrapperService,
    private dataService: DataService
  ) {
    this.isProductionUrl = baseUrl.indexOf("care.novanthealth.org") >= 0;
    this.isRecaptchaValid = baseUrl.indexOf("care.novanthealth.org") < 0;

    const currentYear = new Date().getFullYear();

    this.minDate = new Date(2020, 0, 1); // 0 is January
    this.maxDate = new Date(currentYear, 11, 31); //11 is december

    console.log(this.minDate, this.maxDate);
  }

  ngOnInit() {
    this.addRecaptchaScript();
    this.isPreshift = this.router.url.toLowerCase() == "/verify/pre-shift";
    this.isGovSurvey = this.router.url.toLowerCase() == "/verify/gov-survey";
    if (this.isPreshift) {
      this.btnText = "Start My Screening";
    }

    this.email.valueChanges.subscribe((val) => {
      const s = val ? String(val) : "";
      this.isCorpId = this.endsWithNumberRegex.test(s);
    });
  }

  getLastNameErrorMessage() {
    return this.lastName.hasError("required") ? "You must enter a value" : "";
  }

  getEmailErrorMessage() {
    return this.email.hasError("required")
      ? "You must enter a value"
      : this.email.hasError("pattern")
      ? "Not a valid corpid or email without @novanthealth.org"
      : "";
  }
  getEmployeeIdErrorMessage() {
    return this.employeeId.hasError("required") ? "You must enter a value" : "";
  }

  getNewEmailErrorMessage() {
    return this.newEmail.hasError("required")
      ? "You must enter a value"
      : this.newEmail.hasError("email")
      ? "Not a valid email"
      : "";
  }
  getPhoneNoErrorMessage() {
    return this.phoneNumber.hasError("required")
      ? "You must enter a value"
      : this.phoneNumber.hasError("pattern")
      ? "Please enter 10 digit phone number"
      : "";
  }

  getDateErrorMessage(pickerInput: string | null | undefined): string {
    if (!pickerInput || pickerInput === "") {
      return "Please choose a date.";
    } else {
      const dateParts = pickerInput.split("/");
      if ((dateParts[0] == "2" || dateParts[0] == "02") && dateParts[1] == "29") {
        if (typeof dateParts[2] == "undefined" || dateParts[2] == "") {
          return "Since this is a leap year date, please also add the year.";
        } else {
          return "Since this is a leap year date, please also add the correct year.";
        }
      }
    }
    return "";
  }

  isFormValid() {
    if (this.isNewhire) {
      return this.phoneNumber.valid && this.newEmail.valid;
    } else {
      return this.email.valid && this.employeeId.valid;
    }
  }

  slideButtonChange(event: MatSlideToggleChange) {
    this.isNewhire = event.checked;
  }

  verfiyEmployee() {
    if (!this.isRecaptchaValid) {
      this.toasterWrapper.showError("Please select recaptcha");
      return;
    }

    const dob = moment(this.dateOfBirth.value).format("MM-DD-YYYY");

    if (this.isNewhire) {
      this.verificationData = {
        workEmail: "",
        employeeId: "",
        dateOfBirth: dob,
        phoneNumber: this.phoneNumber.value,
        personalEmail: this.newEmail.value,
      };
    } else {
      let emailOrCorpId = this.email.value;
      if (!this.isCorpId) {
        emailOrCorpId = emailOrCorpId + "@novanthealth.org";
      }
      this.verificationData = {
        workEmail: emailOrCorpId,
        employeeId: this.employeeId.value,
        dateOfBirth: "",
        phoneNumber: "",
        personalEmail: "",
      };
    }

    console.log(this.verificationData);

    this.isSubmitting = true;
    this.surveyService.verifyEmployee(this.verificationData).subscribe(
      (responseData) => {
        this.employee = responseData;
        console.log(this.employee);
        this.isSubmitting = false;
        if (this.employee.firstName != null) {
          this.openSuccessDialog();
          this.verificationData = {
            workEmail: this.employee.workEmail,
            employeeId: this.employeeId.value,
            dateOfBirth: dob,
            phoneNumber: this.employee.cellPhone,
            personalEmail: this.employee.personalEmail,
          };
          console.log("Check verificationData: ", this.verificationData);
        } else {
          if (this.employee.displayName == "NO DOB") {
            this.openSkipDialog(
              "Your date of birth has not been entered into our system. Please submit a ticket to have it populated."
            );
          } else {
            this.openSkipDialog(
              "You may try again or complete your screening at the entry point screening station."
            );
          }
        }
      },
      (error) => {
        console.error(error);
        this.isSubmitting = false;
      }
    );
  }

  openSuccessDialog(): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "450px",
      data: this.employee,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed", result);
      if (result == "continue") {
        this.setAuthAndRedirect(true);
      }
    });
  }

  openSkipDialog(message): void {
    const dialogRef = this.dialog.open(SkipDialogComponent, {
      width: "550px",
      data: { name: "Try Again", message: message },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed", result);
      if (result == "skipped") {
        this.authSkipped = true;
        this.setAuthAndRedirect(false);
      }
    });
  }

  setAuthAndRedirect(isAuthenticated: boolean) {
    console.log("setAuthAndRedirect");
    let authDetails: AuthDetails = {
      employeeInfo: this.employee,
      verificationData: this.verificationData,
      personalInfo: {
        detailId: 0,
        firstName: "",
        lastName: "",
        personalEmail: "",
        cellPhone: "",
        deptnumber: "",
        leadername: "",
        leaderemail: "",
        dateOfBirth: "",
        corpId: "",
        employeeId: "",
      },
      isAuthenticated: isAuthenticated,
      isNewhire: this.isNewhire,
      timestamp: new Date().getTime(),
    };

    console.log(authDetails);

    this.localstorageService.setAuth(authDetails);
    this.localstorageService.showConfirmDialog = false;
    let redirectUrl = this.localstorageService.requestedUrl
      ? this.localstorageService.requestedUrl
      : "/";

    console.log(this.isPreshift, this.isGovSurvey);

    if (this.isPreshift || this.isGovSurvey) {
      redirectUrl = this.localstorageService.requestedUrl
        ? this.localstorageService.requestedUrl
        : "/";
    } else if (this.router.url == "/verify/volunteer") {
      redirectUrl = "/volunteer";
    } else if (this.authSkipped) {
      redirectUrl = "/personal-info";
    }
    this.dataService.currentPageToRedirect$.subscribe((page) => {
      if (page) {
        console.log("Check Home Page Value: ", page);
        redirectUrl = page;
      }
    });
    this.dataService.showHeaderForSPARK$.subscribe((state) => {
      if (state) {
        console.log("State for Spark: ", state);
      }
    });
    console.log("New Deployement is Done.");
    console.log("redirectUrl: ", redirectUrl);

    this.router.navigate([redirectUrl]);
  }

  renderReCaptcha() {
    const win: any = window;
    if (!win["grecaptcha"] || !this.recaptchaElement) {
      return;
    }
    win["grecaptcha"].render(this.recaptchaElement.nativeElement, {
      sitekey: "6Lc9CwATAAAAAFwAvJC-BDXJc2EBwjFGKKiTESWo",
      callback: (response) => {
        console.log(response);
        this.surveyService.verifyRecaptcha(response).subscribe(
          (valResponse: any) => {
            this.isRecaptchaValid = !!valResponse.success;
            console.log(valResponse, this.isRecaptchaValid);
          },
          (error) => {
            console.error(error);
          }
        );
      },
      "expired-callback": () => {
        this.isRecaptchaValid = false;
      },
    });
  }

  addRecaptchaScript() {
    console.log("adding recaptcha");
    let isRecaptchaRendered = false;

    const win: any = window;
    win["grecaptchaCallback"] = () => {
      console.log("rendering");
      this.renderReCaptcha();
      isRecaptchaRendered = true;
    };
    setTimeout(() => {
      if (isRecaptchaRendered == false) {
        console.log("lazy loading recaptcha from timeout");
        this.renderReCaptcha();
      }
    }, 1000);

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src =
        "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "recaptcha-jssdk");
  }
}
